import React, { useContext } from 'react';
import ReactApexChart from 'react-apexcharts';
import { Empty, theme } from 'antd';
import { ApexOptions } from 'apexcharts';
import dayjs from 'dayjs';

import AmazonWebServicesContext from '@totem/components/administration/amazonWebServices/AmazonWebServicesContext';

const AwsMonthlyCostChart = () => {
  const { monthlyCosts } = useContext(AmazonWebServicesContext);
  const { token } = theme.useToken();

  if (monthlyCosts.length === 0) {
    return <Empty description="No cost history synced yet" />;
  }

  const currency = monthlyCosts[0].currency || 'USD';
  const categories = monthlyCosts.map((entry) =>
    dayjs(`${entry.month}-01`).format('MMM YYYY'),
  );
  const values = monthlyCosts.map(
    (entry) => Number.parseFloat(entry.total) || 0,
  );

  const formatCurrency = (value: number, maximumFractionDigits: number) =>
    value.toLocaleString('en-US', {
      style: 'currency',
      currency,
      maximumFractionDigits,
    });

  const options: ApexOptions = {
    chart: {
      type: 'bar',
      toolbar: { show: false },
      background: 'transparent',
    },
    plotOptions: {
      bar: { borderRadius: 4, columnWidth: '55%' },
    },
    dataLabels: { enabled: false },
    colors: [token.colorPrimary],
    xaxis: {
      categories,
      labels: { style: { colors: token.colorTextSecondary } },
      axisBorder: { color: token.colorBorderSecondary },
      axisTicks: { color: token.colorBorderSecondary },
    },
    yaxis: {
      labels: {
        style: { colors: token.colorTextSecondary },
        formatter: (value: number) => formatCurrency(value, 0),
      },
    },
    grid: { borderColor: token.colorBorderSecondary },
    tooltip: {
      y: { formatter: (value: number) => formatCurrency(value, 2) },
    },
    legend: { show: false },
  };

  const series = [{ name: 'Cost', data: values }];

  return (
    <ReactApexChart options={options} series={series} type="bar" height={280} />
  );
};

export default AwsMonthlyCostChart;
